; (function (jQuery) {

	"use strict";

	function GlossaryPopup()
	{
		var pub = {}

		var global = {
			openPopupId: false,
			timeout: 700,
			timer: false,
			yOffset: 14,
			xOffset: 2,
			isTouch: false,
		};

		var fn = {
			init: function()
			{
				pub.pauseVideoPlayerOnClose = fn.pauseVideoPlayerOnClose;
				fn.setupHoverHandlers();
				fn.setupTouchHandlers();
				jQuery('body').on('click', '.js-glossary-link', fn.blockGlossaryLinkOpen);
			},

			setupHoverHandlers()
			{
				jQuery('body').on('mouseenter', '.js-glossary-link', function(e) {
					if (global.isTouch) {
						return;
					}
					var glossaryId = fn.getGlossaryIdFromElem(e.target);
					var thisGlossaryPopup = fn.getPopupElemById(glossaryId);
					jQuery(this).addClass('is-hover');

					if (!thisGlossaryPopup.is(':visible'))
					{
						fn.hidePopup(); // hide previous popup if there's already one open
						global.openPopupId = glossaryId;
						fn.showPopup(e);
					}
					else
					{
						global.timer = false; // cancel the hide timer
					}
				}).on('mouseleave', '.js-glossary-link', function() {
					jQuery(this).removeClass('is-hover');
					fn.startHideTimer();
				});

				jQuery('body').on('mouseenter', '.js-glossary-popup', function() {
					jQuery(this).addClass('is-hover');
				}).on('mouseleave', '.js-glossary-popup', function() {
					jQuery(this).removeClass('is-hover');
					fn.startHideTimer();
					fn.pauseVideoPlayerOnClose(jQuery(this)); // if popup contains iframe
				});
			},

			setupTouchHandlers()
			{
				jQuery('body').on('touchstart', '.js-glossary-link', fn.handleTouch);
				jQuery('body').on('click, touchstart', '.js-glossary-close', fn.hidePopup);
			},

			getGlossaryIdFromElem: function(elem)
			{
				return jQuery(elem).attr('data-glossary-id');
			},

			showPopup: function(e)
			{
				var popupElem = fn.getPopupElemById(global.openPopupId);
				var dimensions = fn.getElemDimensions(popupElem);
				var pos = fn.getEventPos(e, popupElem[0]);

				var windowW = window.document.documentElement['clientWidth'];
				var windowH = window.document.documentElement['clientHeight'];

				// If popup is inside a testimonials slider, use slide dimensions instead of window
				var parentSlide = popupElem[0].closest('.testimonials__slide');
				if (parentSlide)
				{
					windowW = parentSlide.clientWidth;
					windowH = parentSlide.clientHeight;
				}

				var scrollTop = jQuery(window).scrollTop();

				var top = pos.top + global.yOffset;
				var left = pos.left + global.xOffset;

				// Calculate if overflowing bottom of screen
				var popupBottom = (top - scrollTop) + dimensions.height;
				var diff = popupBottom - windowH;

				// If popup is inside a testimonials slider, make sure it does not overflow bottom of slider (would be cropped by overflow:hidden on slider).
				// Also account for height of slider controls, which would cover popup.
				if (parentSlide)
				{
					var slideBottom = parentSlide.offsetTop + parentSlide.clientHeight;
					popupBottom = top + dimensions.height + 60; // 60px height of slider controls
					diff = popupBottom - slideBottom;
				}

				if (diff > 0)
				{
					top = top - diff - 10;
				}

				if (windowW > 600)
				{
					// Calculate if overflowing right of screen
					var popupLeft = (left + dimensions.width);
					var diff = popupLeft - windowW;
					if (diff > 0)
					{
						left = left - diff - 10;
					}

					popupElem.css({
						top: top,
						left: left,
					});
				}
				else
				{
					popupElem.css({
						top: top,
						left: '50%',
						transform: 'translate(-50%, 0)',
					});
				}

				popupElem.show();

				if (global.isTouch) {
					popupElem.addClass('glossary-popup--touch'); // display the close button
				}
			},

			getElemDimensions: function(elem)
			{
				var width = elem.width();
				var height = elem.height();

				return {
					width: width,
					height: height
				}
			},

			getEventPos: function(e, elem)
			{
				var eventPos;
				var parentSlide = elem.closest('.testimonials__slide');

				if (e.touches)
				{
					var touch = e.touches[0];
					eventPos = {
						top: touch.pageY,
						left: touch.pageX,
					};

					// If popup is inside a testimonials slider, get target offset position instead
					if (parentSlide)
					{
						eventPos = {
							top: e.target.offsetTop,
							left: e.target.offsetLeft,
						};
					}
				}
				else
				{
					eventPos = fn.getRelativeMousePos(e, elem);
				}

				return eventPos;
			},

			/**
			 * Get an object with top and left coordinates for the given event's mouse position relative to any
			 * non-static positioned ancestors
			 *
			 * @param {MouseEvent} e
			 * @param {Element} elem
			 * @returns {Object}
			 */
			getRelativeMousePos: function(e, elem)
			{
				var relativeAncestor = fn.getNearestNonStaticAncestor(elem);
				var ancestorYOffset = relativeAncestor ? jQuery(relativeAncestor).offset().top : 0;
				var ancestorXOffset = relativeAncestor ? jQuery(relativeAncestor).offset().left : 0;

				return {
					top: e.pageY - ancestorYOffset,
					left: e.pageX - ancestorXOffset,
				};
			},

			getNearestNonStaticAncestor: function(elem)
			{
				elem = elem.parentElement;

				while (elem && getComputedStyle(elem).position === 'static')
				{
					elem = elem.parentElement;
				}

				return elem;
			},

			hidePopup: function()
			{
				var popupElem = fn.getPopupElemById(global.openPopupId);
				var linkElem = fn.getLinkElemById(global.openPopupId);

				if ((!popupElem.hasClass('is-hover') && !linkElem.hasClass('is-hover')) || global.isTouch) {
					global.openPopupId = false;
					popupElem.fadeOut();
				}

				window.clearTimeout(global.timer);
				global.timer = false;
				global.isTouch = false;
			},

			getPopupElemById: function(glossaryId)
			{
				var popupSelector = '.js-glossary-popup[data-glossary-id=' + glossaryId + ']';
				var glossaryPopupElem = jQuery(popupSelector);

				return glossaryPopupElem;
			},

			getLinkElemById: function(glossaryId)
			{
				var linkSelector = '.js-glossary-link[data-glossary-id=' + glossaryId + ']';
				var glossaryLinkElem = jQuery(linkSelector);

				return glossaryLinkElem;
			},

			startHideTimer: function()
			{
				if (global.timer || global.isTouch) {
					return;
				}

				global.timer = window.setTimeout(fn.hidePopup, global.timeout);
			},

			handleTouch: function(e)
			{
				fn.hidePopup(); // hide previous popup if there's already one open
				global.isTouch = true;
				global.openPopupId = fn.getGlossaryIdFromElem(e.target);
				fn.showPopup(e);
			},

			blockGlossaryLinkOpen: function(e)
			{
				e.preventDefault();
			},

			/**
			 * Stop YouTube video player with pauseVideo() function
			 * See https://www.tutorialspoint.com/How-can-I-stop-a-video-with-JavaScript-in-Youtube
			 * */
			pauseVideoPlayerOnClose: function(content)
			{
				var iframe = content.find('iframe')[0];

				if (iframe) {
					iframe.contentWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', '*');
				}
			}
		};

		jQuery(fn.init);
		return pub;
	}

	window.GlossaryPopup = new GlossaryPopup();
})(jQuery);